import { useIntl } from 'react-intl';

import { TerminalWorkflowType } from '../../../../api/terminals';
import ActionCard from '../../../../components/domain/ActionCard';
import { AllowedActionViewProps } from '../../../../components/domain/AllowedAction';
import useTerminal from '../../../../hooks/useTerminal';
import { isManager, isNSDelivery } from '../../../../services/contact/GlobalPermissions';
import { useChangeDefaultScanner } from '../../../lookup/DefaultScannerContext';
import BadgeRegistrationWorkflow from '../../../nike/registration/BadgeRegistrationWorkflow';

type ResetBadgeActionProps = AllowedActionViewProps;

function ResetBadgeAction(props: ResetBadgeActionProps) {
    const terminal = useTerminal();
    const intl = useIntl();

    if (terminal === null || props.contact === undefined) return undefined;
    if (!((isManager(props.contact) && terminal.workflow === TerminalWorkflowType.IMES_DEXIS_NIKE) || isNSDelivery(props.contact))) return undefined;

    const overwriteUserBadgeAction: ActionCard = {
        actionText: intl.formatMessage({
            id: 'workflow.nike.DashboardWorkflow.ResetBadgeAction',
            description: 'This is the overwrite badge action on the Nike dashboard for the managers',
            defaultMessage: 'Reset badge',
        }),
        icon: <i className='bi bi-person-badge dashboard-action-icon'></i>,
        view: (
            <BadgeRegistrationWorkflow
                badgeValue={undefined}
                overwriteIsEnabled={true}
                onInactivity={props.onInactivity}
                onHome={props.onHome}
            />
        ),
    };

    return overwriteUserBadgeAction;
}

export default ResetBadgeAction;
